import { PrivacyPolicy } from '@gjl/ui'
import { useSEO } from '@/hooks/useSEO'

export default function PrivacyPage() {
  useSEO({
    title: 'Privacy Policy',
    description:
      'How Fugue Lab handles your data. We use analytics cookies only and never sell your personal information.',
    url: '/privacy',
    canonical: '/privacy',
  })

  return (
    <PrivacyPolicy
      orgName="Fugue Lab"
      contactEmail="hello@fuguelab.com"
      siteUrl="https://fuguelab.com"
      analyticsProvider="Google Analytics 4"
      lastUpdated="April 8, 2026"
    />
  )
}
